import React, { useState, useEffect, useCallback, useRef } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import 'dayjs/locale/pt-br.js';
import toast from 'react-hot-toast';
import { entityService } from '../services/entityService.js';
import { medicalRecordService } from '../services/medicalRecordService.js';
import { formatPhone, SPECIES_LABEL } from '../utils/formatters.js';
import placeholderImage from '../images/placeholder.png';
import './Dashboard.css';
import './MedicalRecord.css';

dayjs.extend(relativeTime);
dayjs.locale('pt-br');

function DogIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.15452 1.01195C5.11987 1.32041 7.17569 2.2474 8.72607 3.49603C9.75381 3.17407 10.8558 2.99995 12 2.99995C13.1519 2.99995 14.261 3.17641 15.2946 3.5025C16.882 2.27488 18.8427 1.31337 20.8354 1.01339C21.2596 0.95092 21.7008 1.16534 21.8945 1.55273C22.6719 3.38958 22.6983 5.57987 22.2202 7.49248L22.2128 7.52213C22.0847 8.03536 21.9191 8.69868 21.3876 8.92182C21.7827 9.89315 22 10.9466 22 12.0526C22 14.825 20.8618 17.6774 19.8412 20.2348L19.7379 20.4936C19.1182 22.0486 17.7316 23.1196 16.125 23.418L13.8549 23.8397C13.1549 23.9697 12.4562 23.7172 12 23.2082C11.5438 23.7172 10.8452 23.9697 10.1452 23.8397L7.87506 23.418C6.26852 23.1196 4.88189 22.0486 4.26214 20.4936L4.15891 20.2348C3.13833 17.6774 2.00004 14.825 2.00004 12.0526C2.00004 10.9466 2.21737 9.89315 2.6125 8.92182C2.08046 8.69845 1.91916 8.05124 1.7909 7.53658L1.7799 7.49248C1.32311 5.66527 1.23531 3.2968 2.10561 1.55273C2.29827 1.16741 2.72906 0.945855 3.15452 1.01195ZM6.58478 4.44052C5.45516 5.10067 4.47474 5.9652 3.71373 6.98132C3.41572 5.76461 3.41236 4.41153 3.67496 3.18754C4.68842 3.48029 5.68018 3.89536 6.58478 4.44052ZM20.2863 6.98133C19.5303 5.97184 18.5577 5.11195 17.4374 4.45347C18.3364 3.9005 19.3043 3.45749 20.3223 3.17455C20.5884 4.40199 20.5853 5.76068 20.2863 6.98133ZM8.85364 5.56694C9.81678 5.20285 10.8797 4.99995 12 4.99995C13.1204 4.99995 14.1833 5.20285 15.1464 5.56694C18.0554 6.66661 20 9.1982 20 12.0526C20 14.4676 18.9891 16.9876 18.0863 19.238L18.0862 19.2382C18.0167 19.4115 17.9478 19.5832 17.8801 19.7531C17.5291 20.6338 16.731 21.2712 15.7597 21.4516L13.4896 21.8733L12.912 20.5896C12.7505 20.2307 12.3935 19.9999 12 19.9999C11.6065 19.9999 11.2496 20.2307 11.0881 20.5896L10.5104 21.8733L8.24033 21.4516C7.26908 21.2712 6.471 20.6338 6.12001 19.7531C6.05237 19.5834 5.98357 19.4119 5.91414 19.2388L5.91381 19.238C5.01102 16.9876 4.00004 14.4676 4.00004 12.0526C4.00004 9.1982 5.94472 6.66661 8.85364 5.56694ZM10.5 15.9999C10.1212 15.9999 9.77497 16.2139 9.60557 16.5527C9.43618 16.8915 9.47274 17.2969 9.7 17.5999L11.2 19.5999C11.3889 19.8517 11.6852 19.9999 12 19.9999C12.3148 19.9999 12.6111 19.8517 12.8 19.5999L14.3 17.5999C14.5273 17.2969 14.5638 16.8915 14.3944 16.5527C14.225 16.2139 13.8788 15.9999 13.5 15.9999H10.5ZM9.62134 11.1212C9.62134 11.9497 8.94977 12.6212 8.12134 12.6212C7.29291 12.6212 6.62134 11.9497 6.62134 11.1212C6.62134 10.2928 7.29291 9.62125 8.12134 9.62125C8.94977 9.62125 9.62134 10.2928 9.62134 11.1212ZM16 12.4999C16.8284 12.4999 17.5 11.8284 17.5 10.9999C17.5 10.1715 16.8284 9.49994 16 9.49994C15.1716 9.49994 14.5 10.1715 14.5 10.9999C14.5 11.8284 15.1716 12.4999 16 12.4999Z" fill="currentColor"/>
    </svg>
  );
}

function CatIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.165,12.211A.75.75,0,0,1,10.791,11h2.418a.75.75,0,0,1,.626,1.211l-1.209,1.5a.815.815,0,0,1-1.252,0ZM1.051,15.316a1,1,0,0,1,.633-1.265l.363-.121C2.019,13.623,2,13.314,2,13V2a1,1,0,0,1,1.515-.857L8.037,3.855A8.578,8.578,0,0,1,12,3a8.588,8.588,0,0,1,3.964.855l4.521-2.712A1,1,0,0,1,22,2V13c0,.314-.019.623-.047.93l.363.121a1,1,0,0,1-.632,1.9l-.119-.04a9.94,9.94,0,0,1-1.4,2.843l.541.541a1,1,0,0,1-1.414,1.414l-.442-.442a9.948,9.948,0,0,1-13.7,0l-.442.442a1,1,0,0,1-1.414-1.414l.541-.541a9.94,9.94,0,0,1-1.4-2.843C1.659,16.123,1.214,15.8,1.051,15.316Zm2.963-2.042,3.67-1.223a1,1,0,0,1,.632,1.9L4.334,15.276a7.964,7.964,0,0,0,.939,2.037l3.02-3.02a1,1,0,0,1,1.414,1.414L6.563,18.851a7.952,7.952,0,0,0,10.874,0l-3.144-3.144a1,1,0,0,1,1.414-1.414l3.02,3.02a7.964,7.964,0,0,0,.939-2.037l-3.982-1.327a1,1,0,0,1,.632-1.9l3.67,1.223c0-.091.014-.181.014-.274V3.766L16.515,5.857a1,1,0,0,1-1,.019A6.665,6.665,0,0,0,12,5a6.665,6.665,0,0,0-3.518.876,1,1,0,0,1-1-.019L4,3.766V13C4,13.093,4.011,13.183,4.014,13.274Z"/>
    </svg>
  );
}

function PawIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M382.825,304.576a131.562,131.562,0,0,0-253.65,0l-18.248,66.15A80,80,0,0,0,188.046,472H323.954a80,80,0,0,0,77.119-101.274Zm-20.682,116.5A47.638,47.638,0,0,1,323.954,440H188.046a48,48,0,0,1-46.272-60.765l18.248-66.149a99.563,99.563,0,0,1,191.956,0l18.248,66.149A47.636,47.636,0,0,1,362.143,421.08Z"/>
      <path d="M146.1,230.31c2.784-17.4-.908-36.027-10.4-52.463S111.92,148.9,95.463,142.611c-17.624-6.731-35.6-5.659-50.634,3.017C14.942,162.884,7.077,205.413,27.3,240.433c9.489,16.436,23.778,28.95,40.235,35.236a64.058,64.058,0,0,0,22.863,4.371,55.133,55.133,0,0,0,27.771-7.389C133.194,263.974,143.114,248.937,146.1,230.31Zm-31.6-5.058c-1.43,8.929-5.81,15.92-12.333,19.686S87.4,249,78.95,245.775c-9.613-3.671-18.115-11.251-23.941-21.342-11.2-19.4-8.538-42.8,5.82-51.092a23.483,23.483,0,0,1,11.847-3.058A31.951,31.951,0,0,1,84.044,172.5c9.613,3.673,18.115,11.252,23.941,21.343S116.124,215.091,114.5,225.252Z"/>
      <path d="M149.566,164.017c11.362,9.083,24.337,13.813,37.458,13.812a54.965,54.965,0,0,0,11.689-1.261c33.723-7.331,54.17-45.443,45.58-84.958h0c-4.03-18.546-13.828-34.817-27.588-45.818-14.735-11.78-32.189-16.239-49.147-12.551-33.722,7.33-54.169,45.442-45.58,84.957C126.009,136.745,135.807,153.016,149.566,164.017Zm24.788-99.506a22.258,22.258,0,0,1,4.732-.5c5.948,0,12.066,2.327,17.637,6.781,8.037,6.425,13.826,16.234,16.3,27.621h0c4.76,21.895-4.906,43.368-21.107,46.89-7.361,1.6-15.305-.628-22.367-6.275-8.037-6.426-13.826-16.235-16.3-27.621C148.488,89.506,158.154,68.033,174.354,64.511Z"/>
      <path d="M467.171,145.628c-15.028-8.676-33.013-9.748-50.634-3.017-16.457,6.287-30.746,18.8-40.235,35.236s-13.182,35.067-10.4,52.463c2.982,18.627,12.9,33.664,27.931,42.341a55.123,55.123,0,0,0,27.771,7.389,64.054,64.054,0,0,0,22.863-4.371c16.457-6.286,30.746-18.8,40.235-35.236C504.923,205.413,497.058,162.884,467.171,145.628Zm-10.18,78.805c-5.826,10.091-14.328,17.671-23.941,21.342-8.446,3.228-16.692,2.931-23.215-.837s-10.9-10.757-12.333-19.686c-1.626-10.161.686-21.314,6.513-31.4s14.328-17.67,23.941-21.343a31.955,31.955,0,0,1,11.368-2.221,23.483,23.483,0,0,1,11.847,3.058C465.529,181.631,468.194,205.028,456.991,224.433Z"/>
      <path d="M313.287,176.568a54.965,54.965,0,0,0,11.689,1.261c13.12,0,26.1-4.729,37.458-13.812,13.759-11,23.557-27.272,27.588-45.818,8.589-39.515-11.858-77.627-45.58-84.957-16.957-3.686-34.412.77-49.147,12.551-13.76,11-23.558,27.272-27.588,45.817C259.117,131.125,279.564,169.237,313.287,176.568Zm-14.31-78.16h0c2.474-11.387,8.263-21.2,16.3-27.621,5.572-4.454,11.689-6.781,17.637-6.781a22.258,22.258,0,0,1,4.732.5c16.2,3.522,25.866,25,21.107,46.89-2.476,11.387-8.265,21.2-16.3,27.622-7.061,5.646-15,7.874-22.367,6.275C303.883,141.776,294.217,120.3,298.977,98.408Z"/>
    </svg>
  );
}

function SpeciesIcon({ species }) {
  if (species === 'canine') return <DogIcon />;
  if (species === 'feline') return <CatIcon />;
  return <PawIcon />;
}

/* ── New Pet Modal ── */
function NewPetModal({ isOpen, onClose, entityId, onSaved }) {
  const EMPTY_PET = { name: '', species: '', breed: '', sex: '', birthday: '', weight: '', color: '', neutered: false, neuteredDate: '' };
  const [step, setStep] = useState('owner'); // 'owner' | 'pet'
  const [ownerSearch, setOwnerSearch] = useState('');
  const [ownerResults, setOwnerResults] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [petForm, setPetForm] = useState({ ...EMPTY_PET });
  const [saving, setSaving] = useState(false);
  const photoRef = useRef(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  useEffect(() => {
    if (!isOpen) { setStep('owner'); setOwnerSearch(''); setOwnerResults([]); setSelectedOwner(null); setPetForm({ ...EMPTY_PET }); setPhotoFile(null); setPhotoPreview(null); }
  }, [isOpen]);

  useEffect(() => {
    if (!ownerSearch || ownerSearch.length < 2) { setOwnerResults([]); return; }
    const t = setTimeout(async () => {
      setSearchLoading(true);
      const r = await medicalRecordService.getOwners({ entityId, search: ownerSearch, limit: 8 });
      setOwnerResults(r.success ? (r.owners || []) : []);
      setSearchLoading(false);
    }, 350);
    return () => clearTimeout(t);
  }, [ownerSearch, entityId]);

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Máximo 5MB'); return; }
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleSave = async () => {
    if (!petForm.name.trim()) { toast.error('Nome é obrigatório'); return; }
    setSaving(true);
    const raw = { ...petForm, ownerId: selectedOwner.id, entityId };
    const payload = Object.fromEntries(Object.entries(raw).filter(([, v]) => v !== ''));
    const result = await medicalRecordService.createPet(payload);
    if (!result.success) { toast.error(result.error || 'Erro ao salvar'); setSaving(false); return; }
    let savedPet = result.pet;
    if (photoFile && savedPet?.id) {
      const pr = await medicalRecordService.uploadPetPhoto(photoFile, savedPet.id, entityId);
      if (pr.success) savedPet = { ...savedPet, photo: pr.photoUrl };
    }
    setSaving(false);
    toast.success('Paciente cadastrado!');
    onSaved && onSaved({ ...savedPet, owner: selectedOwner });
    onClose();
  };

  if (!isOpen) return null;

  const inputSt = { width: '100%', padding: '10px 12px', border: '1.5px solid #e5e7eb', borderRadius: '10px', fontSize: '14px', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit', background: '#fff' };
  const labelSt = { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '520px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden', maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#111' }}>Novo Paciente</h2>
            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#9ca3af' }}>{step === 'owner' ? 'Passo 1 de 2 — Selecionar tutor' : 'Passo 2 de 2 — Dados do paciente'}</p>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: '#f3f4f6', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '50%', fontSize: '18px', color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
        </div>

        <div style={{ padding: '20px 24px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '14px' }}>
          {step === 'owner' ? (
            <>
              <div>
                <label style={labelSt}>Tutor</label>
                <input type="text" placeholder="Buscar pelo nome do tutor..." value={ownerSearch}
                  onChange={e => { setOwnerSearch(e.target.value); setSelectedOwner(null); }}
                  style={inputSt} />
                {searchLoading && <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 0' }}>Buscando...</p>}
                {ownerResults.length > 0 && !selectedOwner && (
                  <div style={{ border: '1.5px solid #e5e7eb', borderRadius: '10px', marginTop: '4px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                    {ownerResults.map(o => (
                      <div key={o.id} onClick={() => { setSelectedOwner(o); setOwnerSearch(o.name); setOwnerResults([]); }}
                        style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px', color: '#374151', borderBottom: '1px solid #f3f4f6', background: '#fff' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                        onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                        <strong>{o.name}</strong>
                        {o.phone && <span style={{ marginLeft: '8px', color: '#9ca3af', fontSize: '12px' }}>{formatPhone(o.phone)}</span>}
                        {o.petsCount != null && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#6b7280' }}>{o.petsCount} pet(s)</span>}
                      </div>
                    ))}
                  </div>
                )}
                {selectedOwner && (
                  <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: 'rgba(113,101,255,0.08)', borderRadius: '8px', border: '1.5px solid rgba(113,101,255,0.2)' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#7165FF" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                    <span style={{ fontSize: '13px', color: '#7165FF', fontWeight: '600' }}>{selectedOwner.name}</span>
                    {selectedOwner.phone && <span style={{ fontSize: '12px', color: '#9ca3af' }}>{formatPhone(selectedOwner.phone)}</span>}
                    <button onClick={() => { setSelectedOwner(null); setOwnerSearch(''); }} style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '18px', lineHeight: 1, marginLeft: 'auto', padding: '0 2px' }}>×</button>
                  </div>
                )}
              </div>
              {!selectedOwner && ownerSearch.length >= 2 && ownerResults.length === 0 && !searchLoading && (
                <p style={{ fontSize: '13px', color: '#9ca3af', margin: 0, textAlign: 'center' }}>Nenhum tutor encontrado. Cadastre o tutor primeiro no Prontuário.</p>
              )}
            </>
          ) : (
            <>
              {/* Photo */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => photoRef.current?.click()}>
                  {photoPreview
                    ? <img src={photoPreview} alt="" style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '3px solid var(--color-main)' }} />
                    : <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(113,101,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px dashed var(--color-main)' }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--color-main)" strokeWidth="1.5"><circle cx="12" cy="8" r="5" /><path d="M12 14c-5 0-8 2.5-8 4v2h16v-2c0-1.5-3-4-8-4z" /></svg>
                      </div>
                  }
                  <div style={{ position: 'absolute', bottom: 0, right: 0, width: 24, height: 24, borderRadius: '50%', background: 'var(--color-main)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #fff' }}>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" /><circle cx="12" cy="13" r="4" /></svg>
                  </div>
                </div>
                <span style={{ fontSize: '11px', color: '#9ca3af' }}>Clique para adicionar foto</span>
                <input ref={photoRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePhotoChange} />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div><label style={labelSt}>Nome *</label><input type="text" value={petForm.name} onChange={e => setPetForm(f => ({ ...f, name: e.target.value }))} style={inputSt} placeholder="Ex: Thor" /></div>
                <div>
                  <label style={labelSt}>Espécie</label>
                  <select value={petForm.species} onChange={e => setPetForm(f => ({ ...f, species: e.target.value }))} style={inputSt}>
                    <option value="">Selecionar...</option>
                    {Object.entries(SPECIES_LABEL).map(([value, label]) => (
                      <option key={value} value={value}>{label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div><label style={labelSt}>Raça</label><input type="text" value={petForm.breed} onChange={e => setPetForm(f => ({ ...f, breed: e.target.value }))} style={inputSt} placeholder="Ex: Golden Retriever" /></div>
                <div>
                  <label style={labelSt}>Sexo</label>
                  <select value={petForm.sex} onChange={e => setPetForm(f => ({ ...f, sex: e.target.value }))} style={inputSt}>
                    <option value="">Selecionar...</option>
                    <option value="male">Macho</option>
                    <option value="female">Fêmea</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div><label style={labelSt}>Data de Nascimento</label><input type="date" value={petForm.birthday} onChange={e => setPetForm(f => ({ ...f, birthday: e.target.value }))} style={inputSt} /></div>
                <div><label style={labelSt}>Peso (kg)</label><input type="number" step="0.1" value={petForm.weight} onChange={e => setPetForm(f => ({ ...f, weight: e.target.value }))} style={inputSt} /></div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input type="checkbox" id="np-neutered" checked={petForm.neutered} onChange={e => setPetForm(f => ({ ...f, neutered: e.target.checked }))} style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: 'var(--color-main)' }} />
                <label htmlFor="np-neutered" style={{ fontSize: '13px', color: '#374151', cursor: 'pointer' }}>Castrado(a)</label>
              </div>
              {petForm.neutered && (
                <div>
                  <label style={labelSt}>Data de Castração</label>
                  <input type="date" value={petForm.neuteredDate} onChange={e => setPetForm(f => ({ ...f, neuteredDate: e.target.value }))} style={inputSt} />
                </div>
              )}
            </>
          )}
        </div>

        <div style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          {step === 'pet' && <button onClick={() => setStep('owner')} style={{ padding: '10px 20px', border: '1.5px solid #e5e7eb', borderRadius: '10px', background: '#fff', color: '#374151', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>Voltar</button>}
          <button onClick={onClose} style={{ padding: '10px 20px', border: '1.5px solid #e5e7eb', borderRadius: '10px', background: '#fff', color: '#374151', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>Cancelar</button>
          {step === 'owner'
            ? <button onClick={() => { if (!selectedOwner) { toast.error('Selecione um tutor'); return; } setStep('pet'); }} style={{ padding: '10px 24px', border: 'none', borderRadius: '10px', background: 'var(--color-main)', color: '#fff', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>Continuar →</button>
            : <button onClick={handleSave} disabled={saving} style={{ padding: '10px 24px', border: 'none', borderRadius: '10px', background: 'var(--color-main)', color: '#fff', fontSize: '14px', fontWeight: '700', cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}>{saving ? 'Salvando...' : 'Cadastrar Paciente'}</button>
          }
        </div>
      </div>
    </div>
  );
}

/* ── Main Component ── */
function Pacientes({ onNavigateToPet }) {
  const [entity, setEntity] = useState(null);
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterSpecies, setFilterSpecies] = useState('all');
  const [filterStatus, setFilterStatus] = useState('active');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [showNewModal, setShowNewModal] = useState(false);

  const LIMIT = 20;

  useEffect(() => {
    entityService.getMyEntities().then(r => {
      if (r.success && r.entities?.length > 0) setEntity(r.entities[0]);
      else setLoading(false);
    });
  }, []);

  const loadPets = useCallback(async () => {
    if (!entity) return;
    setLoading(true);
    const params = { entityId: entity.id, page, limit: LIMIT };
    if (search) params.search = search;
    if (filterSpecies !== 'all') params.species = filterSpecies;
    if (filterStatus === 'active') params.inactive = false;
    else if (filterStatus === 'inactive') params.inactive = true;
    const result = await medicalRecordService.getPets(params);
    if (result.success) {
      setPets(result.pets ?? []);
      setTotal(result.total ?? result.pets?.length ?? 0);
    }
    setLoading(false);
  }, [entity, search, filterSpecies, filterStatus, page]);

  useEffect(() => { if (entity) loadPets(); }, [loadPets, entity]);
  useEffect(() => { setPage(1); }, [search, filterSpecies, filterStatus]);

  // Stats from loaded pets
  const statsTotal = total || pets.length;
  const statsActive = pets.filter(p => p.active !== false).length;
  const statsCanine = pets.filter(p => p.species === 'canine').length;
  const statsFeline = pets.filter(p => p.species === 'feline').length;

  const pct = (n) => statsTotal ? `${Math.round((n / statsTotal) * 100)}%` : '—';

  return (
    <div>
      {showNewModal && (
        <NewPetModal
          isOpen={showNewModal}
          onClose={() => setShowNewModal(false)}
          entityId={entity?.id}
          onSaved={(newPet) => { setPets(p => [newPet, ...p]); setTotal(t => t + 1); }}
        />
      )}

      {/* Header */}
      <div className="mr-tutores-header">
        <div>
          <h1 className="mr-tutores-title">Gestão de Pacientes</h1>
          <p className="mr-tutores-subtitle">Gerencie e visualize todos os animais registrados na clínica.</p>
        </div>
        <button onClick={() => setShowNewModal(true)}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', border: 'none', borderRadius: '10px', background: 'var(--color-main)', color: '#fff', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
          Novo Paciente
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '14px', marginBottom: '24px' }}>
        {[
          { label: 'Total Pacientes', value: statsTotal, sub: null, icon: 'people', border: '#7165FF' },
          { label: 'Ativos', value: statsActive, sub: `${pct(statsActive)} da base total`, icon: 'check', border: '#f59e0b' },
          { label: 'Cachorros', value: statsCanine, sub: `${pct(statsCanine)} da base`, icon: 'dog', border: '#7165FF' },
          { label: 'Gatos', value: statsFeline, sub: `${pct(statsFeline)} da base`, icon: 'cat', border: '#7165FF' },
        ].map(({ label, value, sub, icon, border }) => (
          <div key={label} style={{ background: '#fff', border: `1px solid #e5e7eb`, borderTop: `3px solid ${border}`, borderRadius: '12px', padding: '16px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <p style={{ margin: '0 0 6px', fontSize: '12px', fontWeight: '600', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</p>
              <p style={{ margin: 0, fontSize: '28px', fontWeight: '800', color: '#111', lineHeight: 1 }}>{loading ? '—' : value.toLocaleString('pt-BR')}</p>
              {sub && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#9ca3af' }}>{sub}</p>}
            </div>
            <div style={{ width: 36, height: 36, borderRadius: '10px', background: 'rgba(113,101,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-main)', flexShrink: 0 }}>
              {icon === 'people' && <svg width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M382.825,304.576a131.562,131.562,0,0,0-253.65,0l-18.248,66.15A80,80,0,0,0,188.046,472H323.954a80,80,0,0,0,77.119-101.274Zm-20.682,116.5A47.638,47.638,0,0,1,323.954,440H188.046a48,48,0,0,1-46.272-60.765l18.248-66.149a99.563,99.563,0,0,1,191.956,0l18.248,66.149A47.636,47.636,0,0,1,362.143,421.08Z"/><path d="M146.1,230.31c2.784-17.4-.908-36.027-10.4-52.463S111.92,148.9,95.463,142.611c-17.624-6.731-35.6-5.659-50.634,3.017C14.942,162.884,7.077,205.413,27.3,240.433c9.489,16.436,23.778,28.95,40.235,35.236a64.058,64.058,0,0,0,22.863,4.371,55.133,55.133,0,0,0,27.771-7.389C133.194,263.974,143.114,248.937,146.1,230.31Zm-31.6-5.058c-1.43,8.929-5.81,15.92-12.333,19.686S87.4,249,78.95,245.775c-9.613-3.671-18.115-11.251-23.941-21.342-11.2-19.4-8.538-42.8,5.82-51.092a23.483,23.483,0,0,1,11.847-3.058A31.951,31.951,0,0,1,84.044,172.5c9.613,3.673,18.115,11.252,23.941,21.343S116.124,215.091,114.5,225.252Z"/><path d="M149.566,164.017c11.362,9.083,24.337,13.813,37.458,13.812a54.965,54.965,0,0,0,11.689-1.261c33.723-7.331,54.17-45.443,45.58-84.958h0c-4.03-18.546-13.828-34.817-27.588-45.818-14.735-11.78-32.189-16.239-49.147-12.551-33.722,7.33-54.169,45.442-45.58,84.957C126.009,136.745,135.807,153.016,149.566,164.017Zm24.788-99.506a22.258,22.258,0,0,1,4.732-.5c5.948,0,12.066,2.327,17.637,6.781,8.037,6.425,13.826,16.234,16.3,27.621h0c4.76,21.895-4.906,43.368-21.107,46.89-7.361,1.6-15.305-.628-22.367-6.275-8.037-6.426-13.826-16.235-16.3-27.621C148.488,89.506,158.154,68.033,174.354,64.511Z"/><path d="M467.171,145.628c-15.028-8.676-33.013-9.748-50.634-3.017-16.457,6.287-30.746,18.8-40.235,35.236s-13.182,35.067-10.4,52.463c2.982,18.627,12.9,33.664,27.931,42.341a55.123,55.123,0,0,0,27.771,7.389,64.054,64.054,0,0,0,22.863-4.371c16.457-6.286,30.746-18.8,40.235-35.236C504.923,205.413,497.058,162.884,467.171,145.628Zm-10.18,78.805c-5.826,10.091-14.328,17.671-23.941,21.342-8.446,3.228-16.692,2.931-23.215-.837s-10.9-10.757-12.333-19.686c-1.626-10.161.686-21.314,6.513-31.4s14.328-17.67,23.941-21.343a31.955,31.955,0,0,1,11.368-2.221,23.483,23.483,0,0,1,11.847,3.058C465.529,181.631,468.194,205.028,456.991,224.433Z"/><path d="M313.287,176.568a54.965,54.965,0,0,0,11.689,1.261c13.12,0,26.1-4.729,37.458-13.812,13.759-11,23.557-27.272,27.588-45.818,8.589-39.515-11.858-77.627-45.58-84.957-16.957-3.686-34.412.77-49.147,12.551-13.76,11-23.558,27.272-27.588,45.817C259.117,131.125,279.564,169.237,313.287,176.568Zm-14.31-78.16h0c2.474-11.387,8.263-21.2,16.3-27.621,5.572-4.454,11.689-6.781,17.637-6.781a22.258,22.258,0,0,1,4.732.5c16.2,3.522,25.866,25,21.107,46.89-2.476,11.387-8.265,21.2-16.3,27.622-7.061,5.646-15,7.874-22.367,6.275C303.883,141.776,294.217,120.3,298.977,98.408Z"/></svg>}
              {icon === 'check' && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>}
              {icon === 'dog' && <DogIcon />}
              {icon === 'cat' && <CatIcon />}
            </div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div className="mr-tutores-filters">
        <div className="mr-search mr-tutores-search">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
          <input type="text" placeholder="Buscar por nome, raça ou tutor..." value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ border: 'none', outline: 'none', fontSize: '13px', color: '#374151', background: 'transparent', width: '100%' }} />
          {search && <button onClick={() => setSearch('')} style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '18px', lineHeight: 1, padding: 0 }}>×</button>}
        </div>
        <div className="mr-filter-group">
          <span className="mr-filter-label">ESPÉCIE:</span>
          <select value={filterSpecies} onChange={e => setFilterSpecies(e.target.value)} className="mr-filter-select-native">
            <option value="all">Todos</option>
            <option value="canine">Caninos</option>
            <option value="feline">Felinos</option>
            <option value="bird">Aves</option>
            <option value="rodent">Roedores</option>
            <option value="rabbit">Coelhos</option>
            <option value="reptile">Répteis</option>
            <option value="equine">Equinos</option>
            <option value="bovine">Bovinos</option>
            <option value="caprine">Caprinos</option>
            <option value="ovine">Ovinos</option>
            <option value="swine">Suínos</option>
            <option value="fish">Peixes</option>
            <option value="exotic">Exóticos</option>
            <option value="other">Outros</option>
          </select>
        </div>
        <div className="mr-filter-group">
          <span className="mr-filter-label">STATUS:</span>
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="mr-filter-select-native">
            <option value="all">Todos</option>
            <option value="active">Ativos</option>
            <option value="inactive">Inativos</option>
          </select>
        </div>
        <button title="Atualizar" onClick={loadPets} className="mr-action-btn" style={{ flexShrink: 0 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
        </button>
      </div>

      {/* Table */}
      <div className="mr-tutores-table-wrapper">
        <table className="mr-tutores-table">
          <thead>
            <tr>
              <th>Paciente</th>
              <th>Espécie</th>
              <th>Tutor (Proprietário)</th>
              <th>Última Visita</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', padding: '48px', color: '#999' }}>
                <div style={{ padding: '20px' }}>{[1,2,3,4].map(i => <div key={i} className="shimmer" style={{ height: '48px', borderRadius: '8px', marginBottom: '8px' }} />)}</div>
              </td></tr>
            ) : pets.length === 0 ? (
              <tr><td colSpan={6}>
                <div className="mr-empty">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2"><circle cx="12" cy="8" r="5" /><path d="M12 14c-5 0-8 2.5-8 4v2h16v-2c0-1.5-3-4-8-4z" /></svg>
                  <p style={{ margin: '0 0 4px', fontSize: '15px', fontWeight: '600', color: '#374151' }}>Nenhum paciente encontrado</p>
                  <p style={{ margin: 0, fontSize: '13px' }}>{search ? 'Tente ajustar sua busca' : 'Clique em "Novo Paciente" para cadastrar'}</p>
                </div>
              </td></tr>
            ) : pets.map((pet) => (
              <tr key={pet.id} className="mr-tutores-row" onClick={() => onNavigateToPet && onNavigateToPet(pet)}>
                {/* Paciente */}
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', background: '#f3f4f6', flexShrink: 0 }}>
                      <img src={pet.photo || placeholderImage} alt={pet.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.src = placeholderImage; }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: '700', fontSize: '14px', color: '#1A1A1A' }}>{pet.name}</div>
                      {pet.breed && <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>{pet.breed}</div>}
                    </div>
                  </div>
                </td>
                {/* Espécie */}
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#374151' }}>
                    <SpeciesIcon species={pet.species} />
                    <span style={{ fontSize: '13px', fontWeight: '500' }}>{SPECIES_LABEL[pet.species] || pet.species || '—'}</span>
                  </div>
                </td>
                {/* Tutor */}
                <td>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>{pet.owner?.name || pet.ownerName || '—'}</div>
                  {(pet.owner?.phone || pet.ownerPhone) && (
                    <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>{formatPhone(pet.owner?.phone || pet.ownerPhone)}</div>
                  )}
                </td>
                {/* Última Visita */}
                <td>
                  {pet.lastVisitAt ? (
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>{dayjs(pet.lastVisitAt).format('DD MMM, YYYY')}</div>
                      <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>{dayjs(pet.lastVisitAt).fromNow()}</div>
                    </div>
                  ) : <span style={{ color: '#9ca3af', fontSize: '13px' }}>—</span>}
                </td>
                {/* Status */}
                <td>
                  <span className={`mr-status-badge ${pet.active !== false ? 'active' : 'inactive'}`}>
                    {pet.active !== false ? 'ATIVO' : 'INATIVO'}
                  </span>
                </td>
                {/* Ações */}
                <td onClick={e => e.stopPropagation()}>
                  <button className="mr-action-btn" title="Ver prontuário" onClick={() => onNavigateToPet && onNavigateToPet(pet)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {total > 0 && (
        <div className="mr-tutores-pagination">
          <span className="mr-pagination-info">Mostrando <strong>{Math.min((page - 1) * LIMIT + 1, total)} - {Math.min(page * LIMIT, total)}</strong> de <strong>{total}</strong> pacientes</span>
          <div className="mr-pagination-pages">
            <button className="mr-page-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
            </button>
            {(() => {
              const totalPages = Math.ceil(total / LIMIT);
              const pages = [];
              if (totalPages <= 5) { for (let i = 1; i <= totalPages; i++) pages.push(i); }
              else {
                pages.push(1);
                if (page > 3) pages.push('...');
                for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
                if (page < totalPages - 2) pages.push('...');
                pages.push(totalPages);
              }
              return pages.map((p, i) => p === '...' ? (
                <span key={`e${i}`} className="mr-page-ellipsis">...</span>
              ) : (
                <button key={p} className={`mr-page-btn ${p === page ? 'active' : ''}`} onClick={() => setPage(p)}>{p}</button>
              ));
            })()}
            <button className="mr-page-btn" disabled={page >= Math.ceil(total / LIMIT)} onClick={() => setPage(p => p + 1)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6" /></svg>
            </button>
          </div>
          <div style={{ width: '1px' }} />
        </div>
      )}
    </div>
  );
}

export default Pacientes;
